import UserRole from "../../../../common/types/user-role";
import UserPermissions from "../../../../common/utils/user/permissions/user-permissions";
import UserPermissionsDefinition from "../../../../common/utils/user/permissions/user-permissions-definition";

export type OrderOptimizerUserPermissionOption =
  | "hasAccessToCargoView"
  | "hasAccessToTaxiView"
  | "hasAccessToRailyView";

export type OrderOptimizerUserPermissionsDefinition =
  UserPermissionsDefinition<OrderOptimizerUserPermissionOption>;

export type OrderOptimizerUserPermissions =
  UserPermissions<OrderOptimizerUserPermissionOption>;

const OrderOptimizerUserPermissionsDefinition: OrderOptimizerUserPermissionsDefinition =
  {
    hasAccessToCargoView: [UserRole.DISPATCHER],
    hasAccessToTaxiView: [UserRole.DEALER],
    hasAccessToRailyView: [UserRole.ADMIN, UserRole.OPERATOR],
  };

export default OrderOptimizerUserPermissionsDefinition;
